
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 20C4.5 20 0 15.5 0 10S4.5 0 10 0s10 4.5 10 10-4.5 10-10 10zm0-18.5c-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5 8.5-3.8 8.5-8.5-3.8-8.5-8.5-8.5z"}}),_c('path',{attrs:{"d":"M11.3 5.3c-.5 0-.9.3-1 .8-.1.3.1.7.5.8h.2c.5 0 .9-.3 1-.8.1-.3-.1-.7-.5-.8h-.2zM10.5 12.8c-.2.8.5.7 1.4.3h.1v.1c-.5.6-1 1-1.7 1.4-.9.4-1.9.2-1.7-.6l.9-4.2c.2-.9-.6-.8-1.4-.4H8v-.1c.5-.6 1-1 1.7-1.3.9-.4 1.9-.2 1.7.6l-.9 4.2z"}})])
          )
        }
      }
    